import * as React from 'react';
import Modal from '../../components/Modal';
import DevicesOtherIcon from '@mui/icons-material/DevicesOther';
import CreateForm from './CreateForm';
import UpdateForm from './UpdateForm';
import { useCallback } from 'react';
import { updateGroupDevices } from '../../api/api';
import { toast } from 'react-toastify';
import { useDevicesStore } from '../../stores';

const GroupForm = () => {
  const [showAddModal, setShowAddModal] = React.useState(false);
  const { getGroupDevices } = useDevicesStore();

  const handleSubmit = useCallback(
    async (data) => {
      await updateGroupDevices(data);
      setShowAddModal(false);
      toast.success(`Группа устройств "${data.description}" успешно обновлена!`);
      await getGroupDevices();
    },
    [getGroupDevices]
  );

  return (
    <>
      <button onClick={() => setShowAddModal(true)} className="flex items-center cursor-pointer bg-orange-500 hover:bg-orange-600 rounded-full p-2">
        <DevicesOtherIcon className="text-white" />
      </button>
      <Modal showModal={showAddModal} setShowModal={setShowAddModal} title="Создание/редактирование группы устройств">
        <UpdateForm handleSubmit={handleSubmit} />
        <CreateForm handleSubmit={handleSubmit} />
      </Modal>
    </>
  );
};
export default GroupForm;
